export const addFilesToProduct = (payload?: any) => ({
    type: "@saga/ADD_FILES_TO_PRODUCT",
    payload
});

